import { connect } from 'react-redux';
import _get from 'lodash/get';
import { contactSelectors, currentUserSelectors, featureSelectors, userProfileSelectors } from '@lifesize/nucleus';
import JoinModal from 'components/JoinModal/JoinModal';
import { FLAG_VIRTUAL_BACKGROUND } from 'constants/FeatureFlags';

const mapStateToProps = (state, ownProps) => {
  const currentUserInfo = currentUserSelectors.myInfo(state);
  const userName = _get(currentUserInfo, 'name') || _get(state, 'nucleus.auth.credentials.guestName');
  const isAcquiringPrimaryStream = _get(state, 'nucleus.media.isAcquiringPrimaryStream');
  const isGuest = userProfileSelectors.selectIsGuest(state);
  const remoteContact = contactSelectors.getContactByDialStringGenerator(state)(ownProps.extension) || {
    name: ownProps.extension
  };

  return {
    isAcquiringPrimaryStream,
    isGuest,
    remoteContact,
    userName,
    vbbFeatureEnabled: featureSelectors.getFeatureFlag(state)(FLAG_VIRTUAL_BACKGROUND)
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(JoinModal);
